import React, { useEffect, useState } from 'react';
import { _setAxios } from '../../../lib/Helper';
import { Autocomplete, TextField } from '@mui/material';
import { Skeleton } from 'antd';

async function fetchList() {

  return await _setAxios("setting/dropdown/modul/35")
    .then(body => {
      let results = []
      body.data?.data?.forEach(row => {
        results.push({
          label: row.list,
          value: row.id,
        })
      });

      return results
    })
}

const SelectKondisiRuangan = ({ ...props }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    fetchList().then((newOptions) => {
      setOptions(newOptions);
    });
  }, []);

  if (!options.length) return <Skeleton.Button active block />

  return (
    <Autocomplete
      {...props}
      options={options}
      value={options.find(option => option.value === props.value)}
      noOptionsText="Tidak ada data"
      renderInput={(params) => <TextField {...params}
        fullWidth
        label="Kondisi Ruangan"
        size="small"
        InputLabelProps={{
          shrink: true,
        }}
        name="kondisi"
        type="text"
        helperText={
          props.errors.kondisi ? props.errors.kondisi[0] : null
        }
        error={
          props.errors.kondisi
        }
      />}
    />
  );
};
export default SelectKondisiRuangan;
